<template>
  <v-dialog v-model="show" persistent max-width="90vw" max-height="90vh">
    <v-card class="photo-modal-card">
      <v-card-text class="photo-modal-content">
        <div class="photo-container">
          <v-img
            :src="photoUrl"
            contain
            class="photo-image"
          />
        </div>
      </v-card-text>
      <v-card-actions class="photo-modal-actions">
        <v-btn
          v-if="userIsFleetManager"
          color="error"
          @click="removePhoto"
          :loading="deleting"
        >
          <v-icon left>delete</v-icon>
          Delete Photo
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="downloadPhoto">
          <v-icon left>download</v-icon>
          Download
        </v-btn>
        <v-btn color="primary" @click="close">
          <v-icon left>close</v-icon>
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DefectsClient from '@/components/DefectNotices/DefectNoticesClient.vue';

export default {
  mixins: [DefectsClient],
  name: 'PhotoModal',
  props: {
    photoUrl: {
      type: String,
      required: true
    },
    defectId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      show: false,
      deleting: false
    };
  },
  methods: {
    showModal() {
      this.show = true;
    },
    close() {
      this.show = false;
      this.$emit('closed');
    },
    downloadPhoto() {
      const link = document.createElement('a');
      link.href = this.photoUrl;
      link.download = `defect-photo-${Date.now()}.jpg`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async removePhoto() {
      if (!this.defectId) {
        this.$toast.error('Defect ID is required to delete photo');
        return;
      }

      this.deleting = true;

      try {
        const result = await this.deletePhoto(this.defectId);
        if (result && result.status >= 200 && result.status <= 299) {
          this.$toast.success('Photo deleted successfully');
          this.close();
          this.$emit('photo-deleted');
        } else {
          this.$toast.error('Failed to delete photo');
        }
      } catch (error) {
        this.$toast.error('Failed to delete photo');
      } finally {
        this.deleting = false;
      }
    }
  }
};
</script>

<style scoped>
.photo-modal-card {
  height: 90vh;
  display: flex;
  flex-direction: column;
}

.photo-modal-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
}

.photo-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.photo-image {
  max-width: 100%;
  max-height: 100%;
}

.photo-modal-actions {
  padding: 16px;
  border-top: 1px solid #e0e0e0;
}
</style>
